module.exports = __webpack_public_path__ + "media/21.d0bb6ab9.mp3";